import { render } from "./CardImage.vue?vue&type=template&id=8e498cc8&ts=true"
import script from "./CardImage.vue?vue&type=script&lang=ts"
export * from "./CardImage.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__